export const setAgencyList = (state) => ({
    type: 'SET_AGENCY_LIST',
    agencies: state
});
export { setAgencyList as default };
